import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

const AryDefaultProfileImage = ({ size = '32px', fullName }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: size,
        height: size,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: theme.icon.wrappedGreyIcon.backgroundColor,
        color: theme.icon.grey.color
      }}
    >
      {fullName[0]}
    </Box>
  );
};

export default AryDefaultProfileImage;
